
/**
 * Human-readable message for a failed incidents-API mutation. Axios errors
 * ARE `Error` instances, so a bare `err.message` shows the useless
 * "Request failed with status code 409" — the backend's actual reason lives
 * in `response.data.error`.
 */
export function apiErrorMessage(err: unknown, fallback: string): string {
  const e = err as {
    response?: {
      data?: {
        error?: string;
      };
    };
    message?: string;
  };
  const data = e?.response?.data;
  return data?.error || e?.message || fallback;
}
